import { render, staticRenderFns } from "./WebsiteBar.vue?vue&type=template&id=4053fdf8&scoped=true&"
import script from "./WebsiteBar.vue?vue&type=script&lang=js&"
export * from "./WebsiteBar.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteBar.vue?vue&type=style&index=0&id=4053fdf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4053fdf8",
  null
  
)

export default component.exports